// extracted by mini-css-extract-plugin
export default {"SidebarNav":"v4U5rxvp"};